import { css } from '@linaria/core'
import type { FC } from 'react'
import { Trans, useTranslation } from 'react-i18next'
import { fragments } from '#styles/index'

const overwrittenToastMessage = css`
  > .bold {
    ${fragments.textStyle.body.s.bold}
  }
  > .condensed {
    ${fragments.textStyle.body.s.condensedBold}
  }
`

export const OverwrittenToastMessage: FC<{ family: string; from: string; to: string }> = ({ family, from, to }) => {
  const { t } = useTranslation()
  return (
    <div className={overwrittenToastMessage}>
      <Trans
        t={t}
        i18nKey="configuration.optional-equipment.overwritten-toast"
        components={{
          Family: <span className="bold">{family}</span>,
          FromVariant: <span className="condensed">{from}</span>,
          ToVariant: <span className="condensed">{to}</span>,
        }}
        defaults="Your prior selection of <Family /> '<FromVariant />' has been overwritten by the new variant of '<ToVariant />'."
      ></Trans>
    </div>
  )
}
